import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Subscription, merge } from 'rxjs';
import { TranslationService } from '../../core/services/translation.service';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false, 
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private translationService = inject(TranslationService);
  private cdr = inject(ChangeDetectorRef);
  private sub: Subscription;

  constructor() {
    this.sub = merge(
      toObservable(this.translationService.userLang),
      toObservable(this.translationService.adminLang)
    ).subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  transform(key: string): string {
    return this.translationService.translate(key);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
